import descendants from "./descendants";

export const codes = {
    descendants,
};

export default codes;
